module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 8 8",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }